<template>
  <div class="content">
    <div v-if="showPage" class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-75">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-text">
              <h4 class="title">
                Statutory Inspection Item
                <strong v-if="statInspItem.isChargeable"> - Chargeable</strong>
              </h4>
            </div>
            <edit-button
              :visible="
                !statInsp.isPartial && statInspItem.statInspItemStatusId != 3
              "
              @edit-click="editStatInspItem"
            ></edit-button>
          </md-card-header>
          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-small-size-100 md-size-25">
                <p>
                  <strong>Type:</strong>
                  <br />
                  {{ type(statInspItem.statInspItemTypeId) }}
                </p>
                <p
                  v-bind:class="
                    'text-' + status(statInspItem.statInspItemStatusId).colour
                  "
                >
                  <strong>Status:</strong><br />
                  {{ status(statInspItem.statInspItemStatusId).name }}
                </p>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-25">
                <p>
                  <strong>Time Period:</strong>
                  <br />
                  {{ timePeriodText }}
                </p>
                <p>
                  <strong>Number of Repeats:</strong>
                  <br />
                  {{ statInspItem.noOfRepeats }}
                </p>
                <p>
                  <strong>Number of Status Rollbacks:</strong>
                  <br />
                  {{ statInspItem.noOfStatusRollbacks }}
                </p>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-25">
                <p>
                  <strong>Number of Reminders:</strong>
                  <br />
                  {{ statInspItem.noOfEmailReminders }}
                </p>
                <p>
                  <strong>Next Reminder Date:</strong>
                  <br />
                  {{ statInspItem.nextReminderDate | moment("MMMM Do YYYY") }}
                </p>
                <p>
                  <strong>Reminder Frequency:</strong>
                  <br />
                  {{ statInspItem.reminderFrequencyInDays }}
                </p>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-25">
                <p>
                  <strong>Created Date:</strong><br />
                  {{ statInspItem.createdDate | moment("MMMM Do YYYY") }}
                </p>
                <p>
                  <strong>Last Updated:</strong><br />
                  {{
                    statInspItem.lastUpdatedDate | moment("MMMM Do YYYY HH:mm")
                  }}
                </p>
                <p>
                  <strong>Last Updated By:</strong><br />
                  {{ statInspItem.lastUpdatedBy }}
                </p>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-100">
                <p>
                  <strong>Description:</strong>
                  <br />
                  {{ statInspItem.description }}
                </p>
              </div>
            </div>
          </md-card-content>
          <stat-insp-item-actions
            @change-status="changeStatus"
            @close-against-previous="closeAgainstPrevious"
          ></stat-insp-item-actions>
        </md-card>
        <StatInspItemNotes @refresh="getStatInspDetails"></StatInspItemNotes>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-25">
        <StatInspItemQuoteSummary
          @refresh="getStatInspDetails"
        ></StatInspItemQuoteSummary>
      </div>
    </div>
    <StatInspItemChangeStatusForm
      :showModal="showStatusModal"
      :newStatusId="this.selectedStatusId"
      @closeModal="closeModal"
    ></StatInspItemChangeStatusForm>
    <StatInspItemQuoteForm
      :showModal="showQuoteModal"
      :newStatusId="this.selectedStatusId"
      @closeModal="closeModal"
    ></StatInspItemQuoteForm>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {
    StatInspItemChangeStatusForm: () =>
      import("./components/StatInspItemStatusChangeModal"),
    StatInspItemQuoteForm: () => import("./components/StatInspItemQuoteForm"),
    StatInspItemActions: () => import("./components/StatInspItemActions"),
    StatInspItemQuoteSummary: () =>
      import("./components/StatInspItemQuoteSummary"),
    StatInspItemNotes: () => import("./components/StatInspItemNotes")
  },
  data() {
    return {
      showPage: true,
      showStatusModal: false,
      showQuoteModal: false,
      selectedStatusId: -1
    };
  },
  async created() {
    await this.getStatInspDetails();

    if (this.$route.params.statInspId !== this.statInsp.id) {
      await this.$store.dispatch(
        "stat-insp/getStatInsp",
        this.$route.params.statInspId
      );
      if (this.statInsp === undefined) {
        this.showPage = false;
      }
    }
  },
  computed: {
    ...mapGetters({
      statInsp: "stat-insp/statInsp",
      statInspItem: "stat-insp/statInspItem",
      status: "stat-insp/statInspItemStatus",
      type: "stat-insp/statInspItemType",
      timePeriod: "stat-insp/statInspItemTimePeriod",
      noteIcon: "noteIcons"
    }),
    timePeriodText() {
      return this.statInspItem.statInspItemTypeId === 1
        ? this.timePeriod(this.statInspItem.statInspItemTimePeriodId)
        : "ASAP";
    }
  },
  methods: {
    async editStatInspItem() {
      await this.$router.push({
        name: "Edit Stat Insp Item",
        params: { statInspItemId: this.$route.params.statInspItemId }
      });
    },
    async getStatInspDetails() {
      await this.$store.dispatch(
        "stat-insp/getStatInspItemDetail",
        this.$route.params.statInspItemId
      );
    },
    canAddNote() {
      return (
        !this.statInsp.isPartial && this.statInspItem.statInspItemStatusId != 3
      );
    },
    changeStatus(statusId) {
      this.selectedStatusId = statusId;
      statusId == 7
        ? (this.showQuoteModal = true)
        : (this.showStatusModal = true);
    },
    closeModal(refresh) {
      this.showQuoteModal = false;
      this.showStatusModal = false;
      this.selectedStatusId = -1;
      if (refresh) this.getStatInspDetails();
    },
    async closeAgainstPrevious() {
      if (
        window.confirm(
          "Are you sure you wish to continue? This action cannot be undone."
        )
      ) {
        await this.$store
          .dispatch(
            "stat-insp/closeRepeatedStatInspItemAgainstPreviousStatInsp",
            this.$route.params.statInspItemId
          )
          .then(() => {
            this.$router.push({
              name: "Statutory Inspection",
              params: { statInspId: this.$route.params.statInspId }
            });
          });
      }
    }
  }
};
</script>
<style>
.text-right .md-table-cell-container {
  display: flex;
  justify-content: flex-end;
}
</style>
